import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const orbit = defineConnector({
  identifier: "orbit",
  name: "Orbit",
  tagLine: "Community analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://app\\.orbit\\.love/api/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Orbit](https://app.orbit.love/), go to **Account Settings → API Tokens** to generate an access token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.orbit.love/api/v1/workspaces",
  },
});
